// extracted by mini-css-extract-plugin
export default {"mainContainer":"LicenceDetailsCenter_mainContainer__PKzr+","leftCol":"LicenceDetailsCenter_leftCol__bxzqn","fontSize":"LicenceDetailsCenter_fontSize__Q+N+f"};